export default "__VITE_ASSET__DjYrISfH__"